var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onBeforeSaveItem(_vm.fallback)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleConfigItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.optionsNotification
              ? _vm._l(_vm.optionsNotification, function (option, idx) {
                  return _c(
                    "div",
                    { key: `option-${idx}`, staticClass: "mb-3" },
                    [
                      _c("h6", { staticClass: "font-weight-normal" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(option.name) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mt-2" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _vm._l(option.events, function (item) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: `option-item-${item.id}`,
                                    staticClass: "form-group",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-check city-form-check",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.form.events,
                                              expression: "form.events",
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "",
                                              expression: "''",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "checkbox",
                                            disabled: _vm.readonlyFormItem,
                                            id: `cb-item-${item.id}`,
                                            name: `cb-item-${item.id}`,
                                          },
                                          domProps: {
                                            value: item.id,
                                            checked: Array.isArray(
                                              _vm.form.events
                                            )
                                              ? _vm._i(
                                                  _vm.form.events,
                                                  item.id
                                                ) > -1
                                              : _vm.form.events,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.form.events,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = item.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.form,
                                                      "events",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.form,
                                                      "events",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.form,
                                                  "events",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "form-check-label h-auto",
                                            attrs: {
                                              for: `cb-item-${item.id}`,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column align-items-start",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(_vm._s(item.name)),
                                                ]),
                                                _vm._v(" "),
                                                item.help
                                                  ? _c("small", [
                                                      _vm._v(_vm._s(item.help)),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("h6", { staticClass: "font-weight-normal" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t(
                        `${_vm.pageID}.config.admin.custom_admin_email.recipients.title`
                      )
                    ) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "mt-2" }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      `${_vm.pageID}.config.admin.custom_admin_email.recipients.description`
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "emails",
                              expression: "'emails'",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: _vm.readonlyFormItem,
                            disabled: _vm.readonlyFormItem,
                            id: "input-custom_admin_email_recipients",
                            name: "custom_admin_email_recipients",
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "custom_admin_email_recipients"
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "custom_admin_email_recipients"
                            ),
                            helpText: `${_vm.pageID}.config.admin.custom_admin_email.recipients.help`,
                          },
                          model: {
                            value: _vm.form.custom_admin_email_recipients,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "custom_admin_email_recipients",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.custom_admin_email_recipients",
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.pageID}.config.admin.custom_admin_email.recipients.label`
                                )
                              ) +
                              "\n                                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
                showCancelButton: !!_vm.fallback,
              },
              on: {
                save: function ($event) {
                  return _vm.onBeforeSaveItem(_vm.fallback)
                },
                cancel: function ($event) {
                  return _vm.handleBack(_vm.fallback, true)
                },
              },
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }